/**
 * created by li si yi
 * 统计图内容组件
 */
import React from 'react';
import BaseComponent from "../../../../base/BaseComponent";
import {Button, Icon, Spin, Empty} from "antd";
import Echarts from "./Echarts";
import {Scrollbars} from "react-custom-scrollbars";
import webNews from "../images/webNews.png";
import douyin from "../images/douyin.png";
import material from "../images/material.png";
import baijiahao from "../images/baijiahao.png";
import kuaishou from "../images/kuaishou.png";
import weibo from "../images/weibo.png";
import defaultImg from "../images/default.png";

class StatisticsModule extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            currentSelect: 'month',// 当前选择时间
            params: {},
            dataSource: [],// 总数据
            exportType: 1,// 导出类型默认
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        // setTimeout(() => {
        //     if (this.props.chartsData && this.props.chartsData.length) {
        //         let dataSource = JSON.parse(JSON.stringify(this.props.chartsData));
        //         console.log("============props============", this.props);
        //         // debugger
        //         this.state.dataSource = dataSource;
        //         this.setState({})
        //     }
        // }, 100)

    }

    componentWillReceiveProps(nextProps, nextContext) {
        // console.log(nextProps, nextContext);
        if (nextProps.chartsData !== this.props.chartsData) {
            this.state.dataSource = nextProps.chartsData;
            this.setState({})
        }
    }

    render() {
        const {loadStatus} = this.props;
        return (
            // height: '100%'
            <div style={{width: '100%'}}>
                <Scrollbars autoHide autoHeight autoHeightMax={"calc(100vh - 204px)"}>
                    {/* {
                        loadStatus ==='start' && <div style={{display: "contents"}}>
                        <Spin style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: '100%'
                        }}/>
                    </div>
                    } */}
                    <Spin style={{display: "flex", justifyContent: "center", alignItems: "center",height: '100%'}} spinning={loadStatus ==='start'}>
                    {
                        this.state.dataSource.length > 0 ? this.renderContent() :
                            <div style={{display: "contents"}}>
                                <Empty style={{
                                    height: '100%'
                                }}/>
                            </div>
                    }
                    </Spin>
                    {
                        loadStatus ==='end'&&this.state.dataSource.length > 0 ? this.renderLoad() : null
                    }
                </Scrollbars>
            </div>
        );
    }

    // 统计模块
    renderContent = () => {
        let {dataSource} = this.state;
        return (
            <>
                {
                    dataSource && dataSource.map((item, index) => {
                        return (
                            <div style={{
                                width: '99%',
                                border: '2px solid #eee',
                                borderRadius: '5px',
                                display: 'flex',
                                height: 300,
                                marginBottom: '20px',
                            }} key={index}>
                                {this.renderLeft(item, index)}
                                {this.renderRight(item, index)}
                            </div>
                        )
                    })
                }
            </>
        )
    };
    renderLeft = (item, index) => {
        let itemImage = "";
        switch (item.mediaTypeCode) {
            case "material":
                itemImage = material;
                break;
            case "douyin":
                itemImage = douyin;
                break;
            case "webNews":
                itemImage = webNews;
                break;
            case "baijiahao":
                itemImage = baijiahao;
                break;
            case "kuaishou":
                itemImage = kuaishou;
                break;
            case "weibo":
                itemImage = weibo;
                break;
            default :
                itemImage = defaultImg;
                break;
        }
        return (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-around',
                height: '100%',
                width: '20%',
                padding: 10,
                borderRight: '2px solid #eee',
                position: 'relative'
            }}>
                <div style={{
                    marginBottom: 10, fontSize: '16px',
                    color: '#000',
                    verticalAlign: 'middle',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                }}>
                    <img alt={""} src={item.mediaLogo ? item.mediaLogo : ""}
                         style={{width: 48, height: 48, marginRight: 10, borderRadius: '50%', objectFit: 'cover'}}/>
                    {item.mediaName ? item.mediaName : ''}
                </div>
                <div style={{margin: '0 0 0 2px'}}>
                    <div style={{fontSize: '12px', color: '#aaa'}}>累计发布数</div>
                    <span style={{
                        fontSize: '20px',
                        verticalAlign: 'middle',
                        color: '#000'
                    }}>{item.allCount ? item.allCount : 0}</span>
                </div>
                <div style={{margin: '0 0 0 2px'}}>
                    <div style={{fontSize: '12px', color: '#aaa'}}>今日发布数</div>
                    <span style={{
                        fontSize: '20px',
                        verticalAlign: 'middle',
                        color: '#000'
                    }}>{item.todayCount ? item.todayCount : 0}</span>
                </div>
                <div style={{margin: '0 0 0 2px'}}>
                    <div style={{fontSize: '12px', color: '#aaa'}}>所属单位</div>
                    <span style={{
                        fontSize: '20px',
                        verticalAlign: 'middle',
                        color: '#000'
                    }}>{item.deptName ? item.deptName : ''}</span>
                </div>
                <img src={itemImage} style={{
                    position: 'absolute',
                    bottom: '5px',
                    left: '5px',
                }}/>
            </div>
        )
    };
    renderRight = (item, index) => {
        const publicStyle = {
            padding: '5px',
            cursor: 'pointer',
        };
        return (
            <div style={{
                width: '80%',
                height: '100%',
                padding: 15,
            }}>
                <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: '5px'}}>
                    <div style={{fontSize: '14px', color: '#000', lineHeight: '32px'}}>{
                        this.state.dataSource[index].monthSelect ?
                            <>近一个月发布共<span
                                style={{fontWeight: 600}}> {item.publishCount ? item.publishCount : 0} </span>篇文章</> :
                            <>近一年发布共<span
                                style={{fontWeight: 600}}> {item.publishCount ? item.publishCount : 0} </span>篇文章</>
                    }
                    </div>
                    <div style={{
                        marginRight: 10,
                        display: 'flex',
                        justifyContent: 'space-between',
                        width: '180px',
                        alignItems: 'center'
                    }}>
                        <div>
                            <span style={{
                                color: item.monthSelect ? this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3") : '#000',
                                borderRadius: '5px 0 0 5px',
                                border: '1px solid',
                                borderColor: item.monthSelect ? this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3") : '#ccc',
                                ...publicStyle
                            }} onClick={() => {
                                this.changeTime(item, index, 1)
                            }}>近一个月</span>
                            <span style={{
                                color: item.yearSelect ? this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3") : '#000',
                                borderRadius: '0 5px 5px 0',
                                border: '1px solid',
                                borderColor: item.yearSelect ? this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3") : '#ccc',
                                ...publicStyle
                            }} onClick={() => {
                                this.changeTime(item, index, 2);
                            }}>近一年</span>
                        </div>
                        <div className={"exportBtn"}>
                            <Button type={"default"} style={{...publicStyle}} onClick={() => {
                                this.props.onExport && this.props.onExport(item);
                            }}>导出</Button>
                            <style>{`
                             .exportBtn button{
                                color:#000 !important;
                             }
                            `}</style>
                        </div>
                    </div>
                </div>
                <div style={{fontSize: '12px', margin: '0 0 10px 5px'}}>单位：篇</div>
                <div>
                    {this.renderEcharts(item)}
                </div>
            </div>
        )
    };
    // echarts
    renderEcharts = (item) => {
        let defaultColors = [
            {
                "mediaTypeCode": "material",
                "color": "80,182,116",
            },
            {
                "mediaTypeCode": "webNews",
                "color": "59,108,242"
            },
            {
                "mediaTypeCode": "weibo",
                "color": "251,85,85"
            },
            {
                "mediaTypeCode": "douyin",
                "color": "251,85,85"
            },
            {
                "mediaTypeCode": "rmapp",
                "color": "255, 189, 58"
            },
            {
                "mediaTypeCode": "default",
                "color": "199, 227, 253"
            }
        ];
        let colors = this.sysConfigGetValueByKey("statistics_echarts_color", defaultColors);
        if (typeof colors === "string") {
            colors = eval(colors);
        }
        let currentItemColor = colors.filter(Item => Item.mediaTypeCode === item.mediaTypeCode);
        let myChartsColor = "";
        if (currentItemColor && currentItemColor.length) {
            myChartsColor = currentItemColor[0].color;// 取配置项颜色
        } else {
            myChartsColor = colors[colors.length - 1].color;// 默认颜色
        }
        return (
            <>
                <Echarts ref={ref => this.echarts = ref} chartsData={item?.dataResult} myChartsColor={myChartsColor}/>
            </>
        )
    };
    // 加载
    renderLoad = () => {
        return (
            <div style={{
                color: 'rgb(25, 190, 107)',
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
                marginBottom: '20px'
            }}>
                <Icon type="check-circle" style={{marginRight: 10, fontSize: '20px'}}/>
                <div>已加载全部</div>
            </div>
        )
    };
    // 年月切换
    /**
     * echart卡片日期切换
     * @param{object} item
     * @param{number} index
     * @param{string} type 需要获取的echart数据密集度 ： 1：按天统计 2：按月统计
     * */
    changeTime = (item, index, type) => {
        if (item.exportType === type) {
            return false
        }
        if (type === 1) {
            item.monthSelect = true;
            item.yearSelect = false;
            item.exportType = 1;
        } else {
            item.monthSelect = false;
            item.yearSelect = true;
            item.exportType = 2;
        }
        // this.state.exportType = type;
        this.props.onChartsCall && this.props.onChartsCall({type: type, currentData: item});
        this.setState({})
    }
}

export default StatisticsModule;